<template>
  <div class="col-12 col-sm-12 col-md-5">
    <nav class="mid-right-nav" v-bind:aria-label="$t('message.language-chooser')">
      <ul>
        <li>
          <a class="language-chooser-link" href="javascript:void(0)" lang="nb" @click="changeLocale('nbo')">Bokmål</a>
        </li>
        <li>
          <a class="language-chooser-link" href="javascript:void(0)" lang="nn" @click="changeLocale('nny')">Nynorsk</a>
        </li>
        <li>
          <a class="language-chooser-link" href="javascript:void(0)" lang="en" @click="changeLocale('eng')">English</a>
        </li>
        <!-- <li>
          <a role="button" href="javascript:void(0)" onclick="javascript:vFact_showconfigbox()">
          <img
            src="../assets/images/settings_button_small.png"
            id="leseWEBtrigger"
            class="no-bdr cursor"
            width="32px"
            height="30px"
            title="Innstillinger for leseWEB"
            :alt="$t('message.speech-synthesis_alt_text')"
          >
          </a>
        </li> -->
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: "Language",
  methods: {
    changeLocale(val) {
      this._i18n._vm.locale = val;
      localStorage.setItem("lang", val);
      window.location.href = "/";
    }
  }
};
</script>
